// Products.js

import { Link } from "react-router-dom";
import list from '../../../assets/icons/list.png';

const Products = (props) => {
    const { productIcons, productCategoryArray, handleLoading } = props;

    // filtering products
    const productCategory = productCategoryArray.filter((category) => category.fields.moreFurnitureCategory === false);

    // Mapping products and associating them with their images
    const productAssetArray = productCategory.map((product) => ({
        product,
        images: productIcons.filter((asset) => product.fields.name.toLowerCase() === asset.fields.title.toLowerCase()),
    }));

    // // Function to sort categories
    const sortProducts = (a, b) => {
        // Keep 'sofas' and 'beds' at the beginning
        if (a.product.fields.name.toLowerCase() === 'sofas') return -1;
        if (b.product.fields.name.toLowerCase() === 'sofas') return 1;

        if (a.product.fields.name.toLowerCase() === 'beds') return -1;
        if (b.product.fields.name.toLowerCase() === 'beds') return 1;

        // Keep the original order for other categories
        return 0;
    };

    // // Sort the categories array
    productAssetArray.sort(sortProducts);

    return (
        <section id="products" className="products">
            <div className="products-content">
                <div className="products-content__heading section-heading">
                    <h1>EXPLORE OUR FURNITURE</h1>
                </div>

                <div className="products-content__icons">
                    <ul>
                        {productAssetArray.map((product) => {
                            return(
                                <li key={product.images[0].sys.id}>
                                    <Link to={product.images[0].fields.title.replace(/\s+/g, '-')}>
                                        <div className="loading">
                                            <div className="loading-bar"></div>
                                        </div>

                                        <img loading="lazy" width={100} height={100} src={product.images[0].fields.file.url} alt={product.images[0].fields.title} onLoad={handleLoading} />
                                        <p className="products-content__icons--name">{product.images[0].fields.title}</p>
                                    </Link>
                                </li>
                            )
                        })}

                        <li>
                            <Link to='/more-furniture'>
                                <img loading="lazy" width={100} height={100} src={list} alt="list icon"></img>
                                <p>More Furniture</p>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default Products;